import { trackPageView } from "@/services/analytics/autoTrack"
import { useEffect } from "react"
import { useLocation } from "react-router"

/**
 * Zero-render component that tracks page views on route changes.
 */
export function AutoTrackPageViews(): null {
  const location = useLocation()

  useEffect(() => {
    trackPageView(location.pathname)
  }, [location.pathname])

  return null
}
